import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import * as PropTypes from 'prop-types';
import { Colors } from '../../consts';
export var LinkColor = {
  dark: Colors.GREY,
  bright: Colors.WHITE,
  red: Colors.RED
};
export var linkPropTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  target: PropTypes.oneOf([null, '_self', '_blank']),
  title: PropTypes.string
};
export var linkTextPropTypes = _Object$assign({}, linkPropTypes, {
  text: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['dark', 'bright', 'red']),
  hoverColor: PropTypes.oneOf(['dark', 'bright', 'red'])
});
export var linkChevronPropTypes = _Object$assign({}, linkPropTypes, {
  text: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['dark', 'bright', 'red']),
  direction: PropTypes.oneOf(['right', 'left'])
});